<template>
  <div v-if="type !== 'bad_browser'">
    <div
      :class="['stup', { mobile: type === 'mobile' }, { recruiter: recruiter }]"
    >
      <div class="stup__layer">
        <div class="stup__content" :class="{ is_big: type === 'no_active' }">
          <div class="stup__title">{{ title }}</div>
          <div class="stup__text" v-if="type !== 'too_many'">{{ text }}</div>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="bad-browser-wrapper">
    <BadBrowser :locale="locale" class="content" />
  </div>
</template>

<script>
  import BadBrowser from '@/components/interview/BadBrowser.vue';

  export default {
    name: 'stup',

    components: {
      BadBrowser
    },

    props: {
      type: {
        type: String,
        default: ''
      },
      recruiter: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {};
    },

    created() {},

    computed: {
      locale() {
        return this.$store.getters['locale/current'];
      },

      title() {
        if (this.type === 'mobile') {
          return this.$tr('onlineInterview.room.mobileTitle');
        } else if (this.type === 'no_active') {
          return this.$tr('onlineInterview.room.noActiveTitle');
        } else if (this.type === 'finish') {
          return this.$tr('onlineInterview.room.finish');
        } else if (this.type === 'stop_link') {
          return this.$tr('onlineInterview.room.stopLinkTitle');
        } else if (this.type === 'too_many') {
          return this.$tr('onlineInterview.room.tooManyTitle');
        }
      },

      text() {
        if (this.type === 'mobile') {
          return this.$tr('onlineInterview.room.mobileText');
        } else if (this.type === 'no_active') {
          return this.$tr('onlineInterview.room.noActiveText');
        } else if (this.type === 'finish') {
          return '';
        } else if (this.type === 'stop_link') {
          return this.$tr('onlineInterview.room.stopLinkText');
        } else if (this.type === 'too_many') {
          return this.$tr('onlineInterview.room.tooManyText');
        }
      }
    },

    methods: {}
  };
</script>

<style lang="scss" scoped>
  .stup {
    width: 100%;
    height: calc(100vh - 40px);
    position: relative;
    background: url('/static/images/elements/badbrowser/stup.svg') center
      no-repeat;

    &.recruiter {
      height: calc(100vh - 91px);
    }

    &.mobile {
      .stup__title {
        font-size: 22px;
        margin: 0 auto 10px;
        max-width: 260px;
      }
      .stup__text {
        font-size: 18px;
      }
    }

    &__layer {
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
    }

    &__title {
      font-weight: 500;
      font-size: 40px;
      margin-bottom: 15px;
    }

    &__text {
      font-size: 26px;
      max-width: 420px;
      margin: 0 auto;
    }

    &__content {
      color: #f4f5f7;
      width: 800px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;

      &.is_big {
        width: 850px;

        .stup__text {
          max-width: 460px;
        }
      }
    }
  }

  .bad-browser-wrapper {
    max-width: 1200px;
    min-height: calc(100vh - 148px);
    margin: 0 auto;
    padding: 50px 0 0;
  }

  .stup__feedback {
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .stup__feedback-text {
    margin-top: 12px;
    // font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 22px;
    text-align: center;
    color: #f4f5f7;
  }
</style>
